<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/PMReport/BarButlerByBrand'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
                v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM', 
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAgentCodes'"
                    :name="'reAgentCodes'"
                    :select2-options="reAgentCodesOptions"
                    v-model="reAgentCodes"
                    ref="reAgentCodesSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reAgentCodes"
                    :multiple="true"
                    :options="reAgentCodesOptions"
                    v-on:open="LoadreAgentCodesOptions"
                    :clear-on-select="true"
                     v-on:deselect="AgentClearAfterselect"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-------ตัวแทนจำหน่ายย่อย---->
              <div
                class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4"
                v-show="
                  this.$root.canShow([
                    'super_admin',
                    'ADMIN_PM',
                    'AGENT_ADMIN_PM','SUB_AGENT_ADMIN_PM',
                    'COOL_SERVICE_PM',
                  ])
                "
              >
                <div class="form-group">
                  <label>ตัวแทนจำหน่ายย่อย:</label>
                  
                  <select2

                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'" 
                    :id="'pmrSubAgentCodes'"
                    :name="'pmrSubAgentCodes'"
                    :select2-options="pmrSubAgentCodeOptions"
                    v-model="pmrSubAgentCodes"
                    ref="pmrSubAgentCodesSelect2"
                    multiple
                  ></select2>
 
                </div>
              </div>

              <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAmpherId'"
                    :name="'reAmpherId'"
                    :select2-options="reAmpherIdOptions"
                    v-model="reAmpherId"
                    ref="reAmpherIdSelect2"
                  ></select2> -->
 
            <!-------สิ้นสุดตัวแทนจำหน่ายย่อย-->

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>เขตการขาย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reDepartments'"
                    :name="'reDepartments'"
                    :select2-options="reDepartmentsOptions"
                    multiple
                    v-model="reDepartments"
                  ></select2> -->
                  <treeselect
                    v-model="reDepartments"
                    :multiple="true"
                    :options="reDepartmentsOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <!-- <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>Type:</label>
                  <treeselect
                    v-model="reType"
                    :multiple="true"
                    :options="reTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> --> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>BARCODE (เครื่องทำความเย็น):</label>
                  <input
                    v-model="reBarcodeMachine"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทเครื่อง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reMachineType'"
                    :name="'reMachineType'"
                    :select2-options="reMachineTypeOptions"
                    v-model="reMachineType"
                    ref="reMachineTypeSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reMachineType"
                    :multiple="true"
                    :options="reMachineTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>Type(เครื่อง):</label>
                  <treeselect
                    v-model="rePMMachineType"
                    :multiple="true"
                    :options="rePMMachineOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>BARCODE (หัวจ่าย):</label>
                  <input
                    v-model="reBarcodeBarbutler"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาระบุรหัสบาร์โค้ด (มีหลายรหัสให้คั่นด้วย , เช่น 12345,54321)"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทหัวจ่าย:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBarbutlerType'"
                    :name="'reBarbutlerType'"
                    :select2-options="reBarbutlerTypeOptions"
                    v-model="reBarbutlerType"
                    ref="reBarbutlerTypeSelect2"
                    multiple
                  ></select2> -->
                  <treeselect
                    v-model="reBarbutlerType"
                    :multiple="true"
                    :options="reBarbutlerTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>Type(หัวจ่าย):</label>
                  <treeselect
                    v-model="rePMDispenserType"
                    :multiple="true"
                    :options="rePMDispenserOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

             

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    id="reProductBrandId"
                    name="reProductBrandId"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :select2-options="rePMPMBrandOptions"
                    v-model="reProductBrandId"
                    ref="reProductBrandIdSelect2"
                  ></select2> -->
                   <treeselect
                    v-model="reProductBrandId"
                    :multiple="true"
                    :options="rePMPMBrandOptions"
                    :clear-on-select="true"
                    ref="reProductBrandIdSelect2"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>จังหวัด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reProvinceId'"
                    :name="'reProvinceId'"
                    :select2-options="reProvinceIdOptions"
                    v-model="reProvinceId"
                    ref="reProvinceIdSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>อำเภอ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAmpherId'"
                    :name="'reAmpherId'"
                    :select2-options="reAmpherIdOptions"
                    v-model="reAmpherId"
                    ref="reAmpherIdSelect2"
                  ></select2>
                </div>
              </div>


              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทร้านค้า:</label>
                  <treeselect
                    v-model="rePMShopTypeId"
                    :multiple="true"
                    :options="rePMShopTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
             <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะประเภทร้านค้า:</label>
                  <treeselect
                    v-model="shmShopGroupId"
                    :multiple="true"
                    :options="shmShopGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>ประเภทการล้างเครื่อง:</label>
                  <treeselect
                    v-model="shmPMTypeId"
                    :multiple="true"
                    :options="shmPMTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div> 


               <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reShopStatus'"
                    :name="'reShopStatus'"
                    :select2-options="reShopStatusOptions"
                    v-model="reShopStatus"
                    ref="reShopStatusSelect2"
                  ></select2>
                </div>
              </div>
              

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group ">
                  <label class="label">ข้อมูลระหว่างวันที่(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reStartDate"
                      name="reStartDate"
                      ref="reStartDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4">
                <div class="form-group">
                  <label class="label">ข้อมูลระหว่างวันที่(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      readonly
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reEndDate"
                      name="reEndDate"
                      ref="reEndDate"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 col-lg-4 col-md-4 .col-sm-4 col-xs-4" style="display: none;">
                <div class="form-group">
                  <label>สถานะ:</label>
                  <div class="form-check">
                    <label class="form-check-label kt-checkbox">
                      <input
                        id="reIsTransaction"
                        name="reIsTransaction"
                        v-model="reIsTransaction"
                        type="checkbox"
                        class="form-check-input"
                      />
                      สถานะปัจจุบัน
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset($event)"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportMasterShop"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">

              
               
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="BarbutlerTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="33">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    

                    <th class="all text-center">รหัสตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย/ตัวแทนจำหน่ายย่อย</th>
                    <th class="all text-center">ประเภทตัวแทนจำหน่าย</th>
                    <th class="all text-center">เขตการขาย</th>
                    <th class="all text-center">รหัสร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า</th>
                    <th class="all text-center">ชื่อร้านค้า 2</th>
                    <th class="all text-center">ประเภทร้านค้า</th>
                    <th class="all text-center">สถานะประเภทร้านค้า</th>
                    <th class="all text-center">ประเภทการล้างเครื่อง</th>
                    <th class="all text-center">Module</th>
                    <th class="all text-center">วันที่บันทึกข้อมูลอุปกรณ์</th>
                    <th class="all text-center">วัน</th>
                    <th class="all text-center">เดือน</th>
                    <th class="all text-center">ปี</th>
                    <!-- <th class="all text-center">Type</th> -->
                    <!-- <th class="all text-center">รหัสบาร์โค้ด เครื่อง</th> -->
                    <th class="all text-center">BARCODE (เครื่องทำความเย็น)</th>
                    <th class="all text-center">ประเภทเครื่องทำความเย็น</th>
                    <th class="all text-center">Type (เครื่องทำความเย็น)</th>
                    <th class="all text-center">Type (หัวจ่าย)</th>
                    <!-- <th class="all text-center">รหัสบาร์โค้ด หัวจ่าย</th> -->
                    <th class="all text-center">BARCODE (หัวจ่าย)</th>
                    <th class="all text-center">ประเภทหัวจ่าย</th>
                    
                   

                     

                    <!-- <th v-for="(item, key) in brandColumns" :key="key" class="all text-center" >{{ item.name }}</th>   -->
                 
                    <!-- <th class="all text-center" >Leo</th>
                    <th class="all text-center">Asahi</th>
                    <th class="all text-center">Carlsberg</th>
                    <th class="all text-center">Kopper</th>
                    <th class="all text-center">Kronenbourg</th>
                    <th class="all text-center">Snowy</th>
                    <th class="all text-center">ANDAMAN</th>
                    <th class="all text-center">BUSSABA</th>
                    <th class="all text-center">DH-Est.33</th>
                    <th class="all text-center">Singha Light</th>
                    <th class="all text-center">U Korn Beer</th>
                    <th class="all text-center">CHALAWAN PALE ALE</th>
                    <th class="all text-center">CHATRI IPA</th>
                    <th class="all text-center">HOF</th>
                    <th class="all text-center">Other</th> -->
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
 

    return {
      
      rePMShopTypeId: [],
      shmShopGroupId: [],
      shmPMTypeId : [] ,
      shmPMTypeIdOptions : [] ,
      rePMShopTypeIdOptions: [], 
      shmShopGroupIdOptions: [],

       rePMPMBrandOptions: [],

      reAaIsInitial: true,
      reAaDateReq: null,
      reDepartments: [],
      reAgentCodes: [],
      reMachineType: [],
      reBarbutlerType: [],
      reBarcodeMachine: null,
      reBarcodeBarbutler: null,
      reShopStatus: 'ACTIVE',
      reProductBrandId: null,
      reProvinceId: null,
      reAmpherId: null,
      brandHeaders: [],
      reDepartmentsOptions: [],
      // reType: [],
      reIsTransaction: true,
      reStartDate: null,
      reEndDate: null,
      pmrSubAgentCodes : [],
      pmrSubAgentCodeOptions : [], 
      rePMMachineType: [],
      rePMMachineOptions: [
        {
          id: "บริษัท",
          label: "บริษัท",
        },
        {
          id: "เครื่องเช่า",
          label: "เครื่องเช่า",
        },
        {
          id: "ส่วนบุคคล",
          label: "ส่วนบุคคล",
        },
      ],
      rePMDispenserType: [],
      rePMDispenserOptions: [
        {
          id: "บริษัท",
          label: "บริษัท",
        },
        {
          id: "เครื่องเช่า",
          label: "เครื่องเช่า",
        },
        {
          id: "ส่วนบุคคล",
          label: "ส่วนบุคคล",
        },
      ], 
      brandColumns : [], 
      reAgentCodesOptions: [], 
      reShopTypeIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/ShopType/Select2SearchShopType",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reShopStatusOptions: {
        placeholder: "ทั้งหมด",
        allowClear: true,
        data: [
          { id: "ACTIVE", text: "ร้านเปิด", data: null },
          { id: "INACTIVE", text: "ร้านปิด", data: null },
        ],
      }, 
      reProvinceIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchProvince",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAmpherIdOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/MasterLocation/Select2SearchAmpher",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              provinceId: self.reProvinceId,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      pmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.reAgentCodes,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 

      reMachineTypeOptions: [], 
      reBarbutlerTypeOptions: [], 
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.reDepartments = [];
      self.reAgentCodes = [];
      self.reMachineType = [];
      self.reBarbutlerType = [];
      self.reShopStatus = 'ACTIVE';
      self.reProductBrandId = null;
      self.reAmpherId = null;
      self.reProvinceId = null;
      self.reBarcodeMachine = null;
      self.reBarcodeBarbutler = null;
      // self.reType = [];
      self.rePMMachineType = [];
      self.rePMDispenserType = [];
      self.reIsTransaction = true;
      self.reStartDate = null;
      self.reEndDate = null;
      self.pmrSubAgentCodes = [];
      self.pmrSubAgentCodeOptions = [];
 
      self.rePMShopTypeId = [];
      self.shmShopGroupId = []; 
      self.shmPMTypeId = [] ;

      $("#reBarbutlerType")
        .val("")
        .trigger("change");

      $("#reMachineType")
        .val("")
        .trigger("change");

      $("#reDepartments")
        .val("")
        .trigger("change");

      $("#reAgentCodes")
        .val("")
        .trigger("change");

        $("#pmrSubAgentCodes")
        .val("")
        .trigger("change");

      $("#reShopStatus")
        .val("")
        .trigger("change");

      $("#reProductBrandId")
        .val("")
        .trigger("change");

      $("#reProvinceId")
        .val("")
        .trigger("change");

      $("#reAmpherId")
        .val("")
        .trigger("change");

      $("#reStartDate")
        .val("")
        .trigger("change");

      $("#reEndDate")
        .val("")
        .trigger("change");

      this.formSubmit(e, e.target.innerText);
    },
    formSubmit: function(e, innerText = null) {
      let self = this;

      if (innerText == "ล้างค่าทั้งหมด") {
        self.reAaIsInitial = true;
      }

      e.preventDefault();
      var table = $("#BarbutlerTable").DataTable();
      table.draw();
    },
    exportMasterShop: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportBarbutler",
        responseType: "arraybuffer",
        data: {
          AgentCode: self.reAgentCodes,
          SubAgentCode: self.pmrSubAgentCodes,
          Department: self.reDepartments,
          ProductBrands: self.reProductBrandId,
          Status: self.reShopStatus,
          ProvinceId: self.reProvinceId,
          AmperId: self.reAmpherId,
          BarcodeMachine: self.reBarcodeMachine,
          BarcodeMachineType: self.reMachineType,
          BarcodeBarbutler: self.reBarcodeBarbutler,
          BarcodeBarbutlerType: self.reBarbutlerType,
          // Type: self.reType,
          MachineType: self.rePMMachineType,
          DispenserType: self.rePMDispenserType,
          IsTransaction: !self.reIsTransaction,
          StartDate:
            self.reStartDate != null
              ? self.reStartDate.format("DD/MM/YYYY")
              : self.reStartDate,
          EndDate:
            self.reEndDate != null
              ? self.reEndDate.format("DD/MM/YYYY")
              : self.reEndDate, 
            ShopTypeId: self.rePMShopTypeId,
            ShopGroupId: self.shmShopGroupId,  
            PMTypes : self.shmPMTypeId
            
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            // link.download = "ข้อมูลหัวจ่ายแยกตามแบรนด์" + filename;
            link.download = "ข้อมูลหัวจ่าย" + filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    LoadreDepartmentsOptions: function(e) {
      var self = this;
      
      axios
        .get("/Api/MasterSalesArea/FindOptions", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reDepartmentsOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAgentCodesOptions: function(e) {
      var self = this;
      self.reAgentCodesOptions = [
        { id: "", label: "Loading...", isDisabled: true },
      ];
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          {
            page: 1,
            province_id: [],
            department: self.reDepartments,
            AgentCodes: [],
            all: true,
          }
        )
        .then(function(response) {
          if (response.status == 200) {
            self.reAgentCodesOptions = [];
            var data = response.data.results;
            data.forEach((element) => {
              self.reAgentCodesOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreMachineTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2MachineType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reMachineTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBarbutlerTypeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2BarButlerType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBarbutlerTypeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadShopTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.rePMShopTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadPMTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Select2MasterShopTypePM", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmPMTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    }, 
    LoadShopGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ShopType/Select2SearchShopGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.shmShopGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadrePMPMBrandOptions: function(e) {
      var self = this;
      axios//PM/PMBrandOptions
        .get("/Api/Report/PM/ProductBrandOptions", {
          params: {
            page: 1,
            productTypeId: 6,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            //id: "BUSSABA", text: "BUSSABA", data: null
 
            setTimeout(function() {
                data.forEach((element) => { 
                self.rePMPMBrandOptions.push({
                  id: element.data,
                  label: element.text,
                  data : element.data
                });
 

              });

               self.LoadDataTable(self.rePMPMBrandOptions);

            }, 100);
              

          }
        })
        .catch(function(error) {});
    },
    LoadDataTable : function(e){
      var self = this;
      
      //self.rePMPMBrandOptions.filter(val => val.id.includes(self.reProductBrandId));

      var thead = $(document).find('#BarbutlerTable > thead > tr:eq(1)');
      self.rePMPMBrandOptions.forEach((value, index) => {
          thead.append('<th class="all text-center">  &nbsp;&nbsp;'+value.label+' &nbsp;&nbsp; </th>');
      }); 
        
      var table = $("#BarbutlerTable");

      var lColums  = [];
 
          
      lColums.push({ data: "agentCode", className: "text-center" }); 
      lColums.push({ data: "agentName", className: "text-center" }); 
      lColums.push({
        data: "agentType",
        className: "text-center",
        render: function(data, type, full, meta) {
          return full.agentTypeName;
        },
      });
      lColums.push({ data: "department", className: "text-center" });
      lColums.push({ data: "customerCode", className: "text-center" });
      lColums.push({ data: "name1", className: "text-center" });
      lColums.push({ data: "name2", className: "text-center" });

      lColums.push({ data: "shopTypeName", className: "text-center" });
      lColums.push({ data: "shopGroupName", className: "text-center" });
      lColums.push({ data: "shopPMTypeName", className: "text-center" });

      lColums.push({ data: "module", className: "text-center" });
      lColums.push({
        data: "createDate",
        className: "text-center",
        render: function(data, type, full, meta) {
          return full.createDateFormat;
        },
      });
      lColums.push({ data: "day", className: "text-center" });
      lColums.push({ data: "month", className: "text-center" });
      lColums.push({ data: "year", className: "text-center" }); 
      lColums.push({ data: "barcodeMachineOld", className: "text-center" });
      lColums.push({ data: "barcodeMachineType", className: "text-center" });
      lColums.push({ data: "machineType", className: "text-center" });
      lColums.push({ data: "dispenserType", className: "text-center" }); 
      lColums.push({ data: "barcodeBarbutlerOld", className: "text-center" });
      lColums.push({ data: "barcodeBarbutlerType", className: "text-center" }); 
 
        self.rePMPMBrandOptions.forEach((value, index) => {
         
            lColums.push({
              data: value.label,
              orderable: false,
              className: "text-center",
              render: function(data, type, full, meta) {
                return  full.pmBrands.filter((e) => e.brandId === value.data).map((e) => { return  e.brandSummary });
              },
            });
        }); 
        

      table.DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/BarButler",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reAaIsInitial,
              AgentCode: self.reAgentCodes,
              SubAgentCode: self.pmrSubAgentCodes,
              Department: self.reDepartments,
              ProductBrands: self.reProductBrandId,
              Status: self.reShopStatus,
              ProvinceId: self.reProvinceId,
              AmperId: self.reAmpherId,
              BarcodeMachine: self.reBarcodeMachine,
              BarcodeMachineType: self.reMachineType,
              BarcodeBarbutler: self.reBarcodeBarbutler,
              BarcodeBarbutlerType: self.reBarbutlerType,
              // Type: self.reType,
              MachineType: self.rePMMachineType,
              DispenserType: self.rePMDispenserType,
              IsTransaction: !self.reIsTransaction,
              StartDate:
                self.reStartDate != null
                  ? self.reStartDate.format("DD/MM/YYYY")
                  : self.reStartDate,
              EndDate:
                self.reEndDate != null
                  ? self.reEndDate.format("DD/MM/YYYY")
                  : self.reEndDate,

              ShopTypeId: self.rePMShopTypeId,
              ShopGroupId: self.shmShopGroupId,  
              PMTypes : self.shmPMTypeId

            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
          <'row'<'col-sm-12'tr>>
          <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [30, 50, 100],

        pageLength: 30,

        language: {
          lengthMenu: "Display _MENU_",
        },
        
        // Order settings
        order: [[8, "desc"]],
        columns: lColums,
        columnDefs: [
          {
            targets: [8, 9, 10] /* column index */,
            orderable: false /* true or false */,
          },
        ],
        drawCallback: function(settings) {
          self.reAaIsInitial = false;
          self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");
        },
      });
    },
    AgentClearAfterselect: function(){  
      let self = this; 
      self.pmrSubAgentCodes = []; 
  
      $("#pmrSubAgentCodes").val("").trigger("change"); 
      $(`[class="vue-treeselect__input"]`).val("");
    },
  },
  async mounted() {
    let self = this;

    self.LoadrePMPMBrandOptions();
    self.LoadreDepartmentsOptions();
    self.LoadreAgentCodesOptions();
    self.LoadreMachineTypeOptions();
    self.LoadreBarbutlerTypeOptions(); 
    self.LoadShopTypeIdOptions();
    self.LoadShopGroupIdOptions();
    self.LoadPMTypeIdOptions();
   

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.reStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reStartDate = moment().set("date",1);
    $(self.$refs.reStartDate)
      .datepicker(
        "update",
        !!self.reStartDate ? self.reStartDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reStartDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reEndDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.reEndDate)
      .datepicker(
        "update",
        !!self.reEndDate ? self.reEndDate.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reEndDate = e.dates.length != 0 ? moment(e.date) : null;
      });

   

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/BarButlerByBrand.vue